const CheckTime = (value) => {
    return value === null ? 0 : value
}

export {CheckTime}